import { render } from "./Home.vue?vue&type=template&id=18062e2f&ts=true"
import script from "./Home.ts?vue&type=script&lang=ts&external"
export * from "./Home.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__